export default [
  { label: "بنك الرياض", logo: "1.png" },
  { label: "شركة آل سعيدان للعقارات", logo: "2.png" },
  { label: "بنك البلاد", logo: "3.png" },
  { label: "الشركة السعودية للتنمية و الاستثمار التقني", logo: "4.png" },
  { label: "شركة الاتصالات السعودية", logo: "5.png" },
  { label: "ساب", logo: "6.png" },
  { label: "وزارة الشؤون البلدية و القروية", logo: "7.png" },
  { label: "الهيئة العامة للأوقاف", logo: "8.png" },
  { label: "القسامي للمحاماة", logo: "11.png" },
  { label: "مناسب", logo: "munaseb-logo.svg" },
];
